// Add ref prop to reCAPTCHA to reset for subsequent checks
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Helmet } from "react-helmet-async";

import { useLocation, useNavigate } from "react-router-dom";
import { Form } from "@govtechsg/sgds-react/Form";
import { Button, Tooltip } from "@govtechsg/sgds-react";
import { Toast, ToastContainer } from "@govtechsg/sgds-react/Toast";
import { handleEvtClicks, getUrlParam, constantTimeEqual } from "./helper";

// Components
import HeaderRegComponent from "../Components/HeaderRegComponent";
import FooterComponent from "../Components/FooterComponent";

// Images
import img_onemap_attr from "../images/logo/round/omi_logo_attr@2x.png";
import infoImg from "../assets/icons/info.svg";

const RegisterConfirm = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [email, setRegEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [code, setCode] = useState("");
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Add ref prop to reCAPTCHA component and pass to captchaRef var
  const handleSubmit = async (e) => {
    // console.log(e, 'e')
    const confirmEmail = e.target[0].value;
    // code - OTP
    const code = e.target[1].value;
    const password = e.target[2].value;
    const confirmPassword = e.target[3].value;

    // console.log(email, 'email')
    // console.log(password, 'password')
    // console.log(confirmPassword, 'confirmPassword')

    e.preventDefault();

    // email validation
    if (!email) {
      // use regex
    }

    if (!isAlphanumeric(code)) {
      showToastMessage("Please enter a valid confirmation code");
      return;
    }

    const token = await executeRecaptcha("confirm");

    if (constantTimeEqual(password, confirmPassword)) {
      // console.log('same password')
      confirmRegistration(confirmEmail, token);
    } else {
      setShowPassErr(true);
    }
  };

  const confirmRegistration = (regEmail, token) => {
    //console.log(email, 'in confirmReg')
    var headersForConfirm = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    };
    // console.log(regEmail, 'line 103')
    var confirmDetails = {
      email: regEmail,
      password: password,
      code: code,
      recaptchaBody: token,
    };

    axios
      .post(
        `${process.env.REACT_APP_CONFIRM_REGISTRATION}`,
        confirmDetails,
        headersForConfirm,
      )
      // axios.post('https://omi-gcc.smartgeo.sg/api/public/user/confirmRegistrationTest', confirmDetails, headersForConfirm)
      .then((res) => {
        const { data, status } = res;
        const { access_token, expiry_timestamp } = data;
        if (status === 200) {
          new handleEvtClicks("APIRegistration", {
            Status: "ValidationSuccess",
          });
          // Pass the access token in router state, never in the URL, so it is
          // not captured by analytics, server logs or browser history.
          navigate("/registersuccess", {
            state: { accessToken: access_token, expiry_timestamp: expiry_timestamp },
          });
        }
      })
      .catch((err) => {
        const {
          response: { status, data },
        } = err;
        if (status === 400 && data.message === "Recaptcha score is low") {
          showToastMessage(
            "Please refresh and try again or contact OneMap for support",
          );
        } else if (data.error) {
          showToastMessage(data.error);
        } else if (data.message) {
          showToastMessage(data.message);
        } else {
          showToastMessage(status + ": Please contact OneMap for assistance");
        }
      });
  };

  const isAlphanumeric = (str) => {
    return /^[A-Z0-9]+$/.test(str);
  };

  const codeChange = (e) => {
    setCode(e.target.value);
  };

  const passwordChange = (e) => {
    setPassword(e.target.value);
  };

  const confirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const [showToast, setShowToast] = useState(false);
  const [showPassErr, setShowPassErr] = useState(false);

  const [toastText, _setToastText] = useState("");

  const showToastMessage = (_text) => {
    _setToastText(_text);

    setShowToast(true);
  };

  const ToastComponent = () => {
    return (
      <ToastContainer>
        <Toast
          className="om-warning"
          show={showToast}
          onClose={() => setShowToast(false)}
        >
          <Toast.Header>
            <img src={img_onemap_attr} className="rounded me-2" alt="OneMap" />
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>
            <small>{toastText}</small>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  };
  const ToastErr = () => {
    return (
      <ToastContainer>
        <Toast
          className="om-warning"
          show={showPassErr}
          onClose={() => setShowPassErr(false)}
        >
          <Toast.Header>
            <img src={img_onemap_attr} className="rounded me-2" alt="OneMap" />
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>
            <small>Password and Confirm Password does not match.</small>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    );
  };

  useEffect(() => {
    // console.log(email, 'at useEffect')
    if (location && location.state && location.state.email) {
      setRegEmail(location.state.email);
    } else {
      setRegEmail(getUrlParam("email"));
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>Confirm Your OneMap API Account | OneMap API</title>
        <meta
          name="description"
          content="Complete your registration for OneMap API access. Enter your confirmation code and set your password to start utilizing Singapore’s geospatial data."
        />
      </Helmet>
      <div className="om-body container-fluid">
        <HeaderRegComponent />
        <div className="om-body-content pageBase">
          {toastText && <ToastComponent />}
          {showPassErr && <ToastErr />}
          <div id="om-section-title" className="om-sections row">
            <h1>Confirm your OneMap API Account</h1>
          </div>

          <div id="om-section-confirm-info" className="om-sections row">
            <div className="row">
              <p>
                Your password must be 12 to 60 characters long. It must fulfil
                at least 3 out of the 4 conditions below
              </p>
              <div>
                <ol type="a">
                  <li>1 lower character&#40;s&#41;</li>
                  <li>1 upper character&#40;s&#41;</li>
                  <li>1 number&#40;s&#41;</li>
                  <li>
                    1 special character&#40;s&#41;
                    <br />
                    &#40;accepted special characters are
                    &#33;&#35;&#36;&#37;&#38;&#40;&#41;&#42;&#45;&#64;&#94;&#95;
                    and NO whitespaces&#41;
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <Form className="form-inline" onSubmit={handleSubmit}>
            <div
              id="om-section-confirm-credentials"
              className="om-sections row"
            >
              <div className="row">
                <Form.Group className="col-md-6 mb-4" controlId="email">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    required
                    defaultValue={email}
                  />
                </Form.Group>

                <Form.Group className="col-md-6 mb-4" controlId="code">
                  <Form.Label>Confirmation Code</Form.Label>
                  <Tooltip content="Refer to email for Confirmation Code">
                    <img className="om-ml6" src={infoImg} alt="infoImg" />
                  </Tooltip>
                  <Form.Control
                    type="code"
                    placeholder="Confirmation Code"
                    onChange={codeChange}
                    defaultValue={code}
                  />
                </Form.Group>
              </div>

              <div className="row">
                <Form.Group className="col-md-6 mb-4" controlId="password">
                  <Form.Label>Password</Form.Label>
                  {/* <FormControlGroup icon={<i className='bi bi-search'></i>}> */}
                  <Form.Control
                    type="password"
                    placeholder="Password"
                    required
                    onChange={passwordChange}
                    defaultValue={password}
                    minLength={12}
                    maxLength={60}
                  />
                  {/* </FormControlGroup>x */}
                </Form.Group>

                <Form.Group
                  className="col-md-6 mb-4"
                  controlId="confirmpassword"
                >
                  <Form.Label>Confirm Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Confirm Password"
                    required
                    onChange={confirmPasswordChange}
                    defaultValue={confirmPassword}
                    minLength={12}
                    maxLength={60}
                  />
                </Form.Group>
              </div>

              <div className="row">
                <div className="inline-block text-center">
                  <Button className="om-btn-form-submit om-red" type="submit">
                    Register
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>

        <FooterComponent />
      </div>
    </>
  );
};

export default RegisterConfirm;
